import { createGlobalStyle } from "styled-components"
export default createGlobalStyle`
 

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
    display: block;
}
body {
    line-height: 1.5;
}
ol,
ul {
    list-style: none;
}
blockquote,
q {
    quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
    content: "";
    content: none;
}
table {
    border-collapse: collapse;
    border-spacing: 0;
}


pre:has(> code.code) {
    background-color: rgb(240 240 240);
    padding:20px 30px;
    font-size:14px;
    border-radius: 5px;
    overflow:auto;
}
p.paragraph:has(> img.image) {
    text-align: center;
}
 
blockquote.blockquote{
    padding: 10px;
    background-color: #ffe3cb;
    border-radius: 10px;
    color: #787878;
    font-size: 14px;
    font-weight: 600;
    font-style: italic;
    margin: 0;
   p{
    line-height: 1.5em;
    :before{
        content:"📎 ";
        font-size: 24px;
    }
   }
}
 
code.code{
    font-family: JetBrains Mono Italic, Noto Sans, Helvetica, sans-serif;
    color: #902525; 
}
code.inlineCode{
    background-color: rgb(240 240 240);
    padding: 2px 5px;
    font-family: JetBrains Mono,Noto Sans, Helvetica, sans-serif;
    font-size: 14px;
    color: #902525;
    border-radius: 5px;
}
 
h1.h1{
    font-size:42px;
}
h2.h2{
    font-size:34px;
    position: relative; 
    display:inline-block ;
}
h2.h2:before{
  content: "";
  width: 105%;
  height: 5px;
  background: #ff7600;
  position: absolute;
  left: 0px;
  top: 95%;  
}
h3.h3{
    font-size:24px;
}
h4.h4{
    font-size:20px;
}
h4.h4:before{
    content: "✓ ";
}
p.paragraph{
    line-height: 1.5em;
}
p.paragraph > img{
    max-width: 590px;
    width:100%;
}
li.li{
    line-height:1.8em;
    
}
strong.strong{
    font-weight:900;
}
a.link{
    font-style: italic;
    padding: 0 5px 0 2px;
    color: #337ab7;
    text-decoration: none;
    font-weight: bold;
    :before{
        content:"🔗 "
    }
}
/* init css */
* {
     
    font-family: Noto Sans, Helvetica, sans-serif;
}

`
